import { render, staticRenderFns } from "./LimitsByCurrencies.vue?vue&type=template&id=661b0b86&scoped=true&"
import script from "./LimitsByCurrencies.vue?vue&type=script&lang=js&"
export * from "./LimitsByCurrencies.vue?vue&type=script&lang=js&"
import style0 from "./LimitsByCurrencies.vue?vue&type=style&index=0&id=661b0b86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661b0b86",
  null
  
)

export default component.exports